import React from "react"
import { StaticQuery, graphql } from "gatsby"

const ContentQuery = ({ id, render: Render, ...rest }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulContentText {
          edges {
            node {
              id
              title
              content { 
                json
              }
              button {
                id
                text
                link
              }
              tags
              useFullWidthImages
            }
          }
        }
        allContentfulContentForm {
          edges {
            node {
              id
              editableContent {
                json
              }
              formFields {
                label
                type
              }
              action
            }
          }
        }
        allContentfulContentWidget {
          edges {
            node {
              id
              type
              editableContent {
                json
              }
            }
          }
        }
        allContentfulContentLink {
          edges {
            node {
              id
              text
              link
              internalLinks {
                __typename
                ...on ContentfulLayout {
                  slug
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const allContent = [
        ...data.allContentfulContentForm.edges,
        ...data.allContentfulContentText.edges,
        ...data.allContentfulContentWidget.edges,
        ...data.allContentfulContentLink.edges,
      ]

      const content = allContent.find(
        ({ node }) => node.id === id
      ) || {}

      return <Render data={content.node} {...rest} />
    }}
  />
)

export default ContentQuery
